import React, { useContext, useState } from 'react'
import { Link } from 'react-router-dom'
import Toggle from '../Toggle/Toggle'
import { themeContext } from '../../Context'
import './Navbar.css'

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const theme = useContext(themeContext)
  const darkMode = theme.state.darkMode

  return (
    <header className={`n-wrapper${darkMode ? ' n-wrapper-dark' : ''}`}>
        <div className="n-left">
            <div className="n-name"> Day Night  </div>
            <Toggle/>
        </div>
        <button
          className="n-menuButton"
          type="button"
          aria-expanded={isMenuOpen}
          aria-controls="main-navigation"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? 'Close pages' : 'Pages'}
          <span aria-hidden="true">{isMenuOpen ? '−' : '+'}</span>
        </button>
        <div className="n-right">
            <nav
              className={`n-list${isMenuOpen ? ' n-list-open' : ''}`}
              id="main-navigation"
              aria-label="Main navigation"
            >
                <ul>
                    <li><Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link></li>
                    <li><Link to="/projects" onClick={() => setIsMenuOpen(false)}>Projects</Link></li>
                    <li className="n-mobileOnlyLink"><Link to="/moon" onClick={() => setIsMenuOpen(false)}>Moon</Link></li>
                    <li><Link to="/bio" onClick={() => setIsMenuOpen(false)}>Biography</Link></li>
                    <li><Link to="/portfolio" onClick={() => setIsMenuOpen(false)}>Portfolio</Link></li>
                    <li className="n-mobileOnlyLink"><Link to="/booking" onClick={() => setIsMenuOpen(false)}>Booking</Link></li>
                    <li><Link to="/podcast" onClick={() => setIsMenuOpen(false)}>Podcast</Link></li>
                    <li><Link to="/give" onClick={() => setIsMenuOpen(false)}>Give</Link></li>
                    <li className="n-mobileOnlyLink">
                      <a href="https://www.submithub.com/link/kushim" target="_blank" rel="noopener noreferrer">Stream</a>
                    </li>
                    <li className="n-mobileOnlyLink">
                      <a href="https://mailchi.mp/7d2f18a7f168/join-peacetribe-newsletter" target="_blank" rel="noopener noreferrer">Newsletter</a>
                    </li>
                </ul>
            </nav>
        </div>
    </header>
  )
}

export default Navbar